export enum AuthType {
  SIGNIN = 'signIn',
  SIGNUP = 'signUp',
}
